/* eslint-disable import/no-unresolved */
/* eslint-disable no-undef */
import React, { useState } from 'react';
import { swalMessages } from 'src/constants';
import { useHistory } from 'react-router-dom';
import UsersCreator from 'src/pages/AdminControl/UsersAdmin/UsersCreator';
import administratorService from 'src/services/administratorService';

function defaultFormValue() {
  return {
    correo: '',
    nombre: '',
    apellido: '',
    clave: '',
  };
}

const UsersContainer = () => {
  const [error, setError] = useState({
    error: false,
    success: false,
  });
  const [user, setUser] = useState(defaultFormValue());
  const history = useHistory();

  /*= =======================================================================
    handleCreate Users
  ========================================================================= */

  const handleCreate = (event) => {
    event.preventDefault();
    administratorService
      .postUser(user)
      .then((response) => {
        if (response.data.id === 0) {
          swal(swalMessages.REPEAT_MESSAGE_ERROR);
        } else {
          swal(swalMessages.SUCCESSFUL_MESSAGE);
          history.push('/adminusers');
        }
      })
      .catch((error) => {
        console.log(error);
        history.push('/home');
      });
  };

  const onChange = (event, type) => {
    setUser({ ...user, [type]: event.target.value });
    if (user.clave.length < 8) {
      setError({ error: true, success: false });
    } else if (user.clave.length >= 8) {
      setError({ error: false, success: true });
    }
  };

  return (
    <>
      <UsersCreator
        onChange={onChange}
        user={user}
        error={error}
        onCreate={handleCreate}
      />
    </>
  );
};

export default UsersContainer;
